import api from "./axios";

const BASE = "/tour-programs";


// Get all tour programs
export const getTourPrograms = (params = {}) =>
  api.get(BASE, { params });


// Admin listing
export const getAdminTourPrograms = (params = {}) =>
  api.get(`${BASE}/admin`, { params });


// Employee own programs
export const getMyTourPrograms = () =>
  api.get(`${BASE}/mine`);


// Create
export const createTourProgram = (payload) =>
  api.post(BASE, payload);


// Update
export const updateTourProgram = (id, payload) =>
  api.patch(`${BASE}/${id}`, payload);


// Delete
export const deleteTourProgram = (id) =>
  api.delete(`${BASE}/${id}`);


// Export Excel
export const exportTourPrograms = (params = {}) =>
  api.get(`${BASE}/export`, {
    params,
    responseType: "blob",
  });